/*
  Product page tweaks that CSS alone cannot do.  (Igor 2026-09-08)

  The low-stock notice ("Only 52 items left in stock!") is injected by the
  Hengam app INSIDE .product-form__buttons, several levels below the price.
  Igor wants it directly above the price. Different parents, so `order` is no
  help; the node has to move.

  The app injects late and re-injects on every variant change, so this watches
  for it rather than running once.
*/
(function () {
  'use strict';

  var STOCK = '.hengam-low-stock-description, [class*="lowStockDescription"]';

  function priceAnchor() {
    // the price block is a direct child of the info container
    var price = document.querySelector('.product__info-container .price');
    if (!price) return null;
    var node = price;
    while (node.parentElement && !node.parentElement.classList.contains('product__info-container')) {
      node = node.parentElement;
    }
    return node.parentElement ? node : null;
  }

  /* Client round 6, 6.2c ("Nog 3 op voorraad") plus the P0 review: the app
     prints English on a Dutch page and sets its colour INLINE with
     !important (#ee442e, 3.64:1 on cream), which no stylesheet can beat.
     The number stays the app's own live count; only the words and the inline
     colour change, so hm-overrides.css decides the colour (#c62f2a, 5.2:1). */
  function localise(stock) {
    stock.querySelectorAll('[style]').forEach(function (el) {
      if (el.style.getPropertyValue('color')) el.style.removeProperty('color');
    });
    if (stock.style && stock.style.getPropertyValue('color')) stock.style.removeProperty('color');
    var walker = document.createTreeWalker(stock, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var m = node.nodeValue.match(/only\s+(\d+)\s+items?\s+left\s+in\s+stock!?/i);
      if (m) {
        var lang = (document.documentElement.lang || 'en').slice(0, 2);
        var words = lang === 'nl' ? 'Nog ' + m[1] + ' op voorraad' : lang === 'fr' ? 'Plus que ' + m[1] + ' en stock' : 'Only ' + m[1] + ' left in stock';
        node.nodeValue = node.nodeValue.replace(m[0], words);
      }
    }
  }

  function move() {
    var stock = document.querySelector(STOCK);
    if (!stock) return;
    localise(stock);
    var anchor = priceAnchor();
    if (!anchor || !anchor.parentElement) return;
    // already in place
    if (stock.nextElementSibling === anchor && stock.parentElement === anchor.parentElement) return;
    stock.classList.add('hm-stock-moved');
    anchor.parentElement.insertBefore(stock, anchor);
  }

  function start() {
    move();
    var host = document.querySelector('.product__info-container') || document.body;
    var pending = false;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; move(); });
    });
    obs.observe(document.body, { childList: true, subtree: true });
    // the app can take a moment on first paint
    [400, 1200, 3000].forEach(function (t) { setTimeout(move, t); });
  }

  /* Sticky add-to-cart bar: only between ~30% and ~90% of the page.

     Igor: "this should also disappear again when the footer has been reached.
     So it starts around 30% is scrolled until around 90%". The theme shows it
     from its own trigger and never hides it again, so it sat over the footer.
     A class on the wrapper gates it; the theme keeps its own animation. */
  function stickyRange() {
    var wrap = document.querySelector('.sticky-cart-wrapper');
    if (!wrap) return;

    // name="add": the wishlist app button also carries .product-form__submit
    var atc = document.querySelector('.product__info-container button[name="add"].product-form__submit');
    var footer = document.getElementById('shopify-section-footer') || document.querySelector('.site-footer, footer');
    var bar = wrap.querySelector('product-sticky-cart');
    var atcOnScreen = false;
    var footerOnScreen = false;

    /* Client round 6, 6.3b: "Zorg dat de CTA op mobiel sticky blijft tijdens
       het scrollen door de productfoto's." On a phone the gallery comes BEFORE
       the buy button, so the 30% rule hid the bar exactly while the photos
       were swiped. Phone: visible from the top of the page, hidden only while
       the real button is on screen and once the footer arrives.

       Visibility is driven by IntersectionObserver, not by scroll position:
       the gallery auto-cycles (hm-gallery-cycle.js) through slides of
       different heights, which moves the buy button with no scroll event, and
       a scroll-only check left the bar up while the real button was visible
       (P3/P4 review). IO fires on layout movement as well as scrolling.
       Desktop keeps Igor's 30-90% window, and never covers the footer. */
    function update() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      var show;
      if (window.innerWidth <= 749) {
        show = !atcOnScreen && !footerOnScreen;
        wrap.classList.toggle('hm-sticky-force', show);
      } else {
        wrap.classList.remove('hm-sticky-force');
        var pct = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
        show = pct >= 30 && pct <= 90 && !footerOnScreen;
      }
      wrap.classList.toggle('hm-sticky-out-of-range', !show);
      liftChat(show && window.innerWidth <= 749);
    }

    /* The Shopify Inbox launcher sat over the right half of the bar's button
       on phones. Inline !important is the only thing that beats the
       !important bottom that hm-chat-position.js puts inside its shadow root. */
    function liftChat(on) {
      var host = document.querySelector('shopify-chat');
      var act = host && host.shadowRoot && host.shadowRoot.querySelector('.activator');
      if (!act) return;
      if (on && bar) act.style.setProperty('bottom', (bar.offsetHeight + 16) + 'px', 'important');
      else act.style.removeProperty('bottom');
    }

    if ('IntersectionObserver' in window) {
      if (atc) new IntersectionObserver(function (e) { atcOnScreen = e[0].isIntersecting; update(); }, { threshold: 0 }).observe(atc);
      if (footer) new IntersectionObserver(function (e) { footerOnScreen = e[0].isIntersecting; update(); }, { threshold: 0 }).observe(footer);
    }

    update();
    window.addEventListener('scroll', function () {
      if (window.requestAnimationFrame) requestAnimationFrame(update);
      else update();
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  /* "Maattabel" next to the size picker opened the store's English "Sizing"
     page in a modal, right above the Dutch table in "Maten en info" (P3/P4
     review). It now opens that accordion and scrolls to it, so there is one
     size table and it is Dutch. Capture phase, so the theme's modal-opener
     listener on the button never fires. */
  function sizeLink() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('.product__info-container .form__popup button[aria-haspopup="dialog"]');
      if (!btn) return;
      var acc = Array.prototype.find.call(document.querySelectorAll('.product__info-container .product__accordion'), function (a) {
        var t = a.querySelector('.accordion__title');
        return t && /^\s*maten/i.test(t.textContent);
      });
      if (!acc) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var d = acc.querySelector('details');
      if (d) d.open = true;
      var y = acc.getBoundingClientRect().top + window.scrollY - 110;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }, true);
  }

  /*
    Mobile gallery height follows the ACTIVE slide.  (Igor 2026-09-13)

    The media list is a flex row, so its height is the TALLEST slide no matter
    which one is showing. Measured at 390px: the tallest photo (326x489) made a
    639px row while the active square photo's box was 427px, leaving 212px of
    dead space under it and pushing the thumbnail strip to y=801, 12px past an
    844 fold. The box itself no longer letterboxes; this is the row around it.

    CSS alone cannot do this: a flex row sizes to its tallest item regardless of
    align-items, and clamping with max-height reintroduces the ratio mismatch
    that the box fix just removed. So the active slide's own box height is
    published as a custom property and the row follows it.
  */
  function galleryHeight() {
    var list = document.querySelector('.product__media-list');
    if (!list) return;

    function apply() {
      if (window.innerWidth > 749) { list.style.removeProperty('--hm-list-h'); return; }
      var active = list.querySelector('.product__media-item.is-active') ||
                   list.querySelector('.product__media-item');
      if (!active) return;
      var box = active.querySelector('.product__media, .media');
      if (!box) return;
      var h = Math.round(box.getBoundingClientRect().height);
      if (h > 0) list.style.setProperty('--hm-list-h', h + 'px');
    }

    apply();
    // the theme swaps .is-active on the slides rather than firing an event
    new MutationObserver(apply).observe(list, {
      subtree: true, attributes: true, attributeFilter: ['class']
    });
    // images arrive after layout, and each one changes its own box height
    Array.prototype.forEach.call(list.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', apply, { once: true });
    });
    window.addEventListener('resize', apply, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); stickyRange(); galleryHeight(); sizeLink(); });
  } else {
    start();
    stickyRange();
    galleryHeight();
    sizeLink();
  }
})();
